// Auswahlwerte der Ticketarten (Stammdaten, Kundenwunsch 13.10.2026: „die bearbeitung der ticketarten grundlegend
// überarbeiten und an unser neues design anpassen“). Werte wie bisher im DevExtreme-Formular von TicketTypeDataGrid.

// Feld type: Nummer und Bezeichnung (Text wie bisher, ausgeschrieben)
export const TICKET_TYPE_KINDS = Object.freeze([
  { value: 0, text: 'Normales Ticket' },
  { value: 1, text: '– (1)' },
  { value: 2, text: 'Wochenkarte KW' },
  { value: 3, text: 'Monatskarte' },
  { value: 4, text: 'Wochenkarte Mo.' },
  { value: 5, text: '365-Euro-Ticket' },
  { value: 6, text: 'Vario Monat' },
  { value: 7, text: 'LAVV Jahresticket' },
  { value: 8, text: 'Barbeleg/Quittung' },
  { value: 9, text: 'EBE' },
  { value: 10, text: 'Quittung (Freipreis)' }
]);

export function kindText(value) {
  const n = Number(value);
  const kind = TICKET_TYPE_KINDS.find(k => k.value === n);
  return kind ? kind.text : (value === null || value === undefined || value === '' ? '–' : 'Typ ' + value);
}

// Druckdefinition: Steuer-Tags des Fahrscheindruckers (Code und Bedeutung)
export const PRINT_TAGS = Object.freeze([
  { code: '<F>', text: 'Fett' },
  { code: '<I>', text: 'Kursiv' },
  { code: '<U>', text: 'Unterstreichen' },
  { code: '<Z>', text: 'Zentriert' },
  { code: '<R>', text: 'Rechtsbündig' },
  { code: '<FA>', text: 'Sans Serif' },
  { code: '<FB>', text: 'Sans Serif Condensed' },
  { code: '<FM>', text: 'Monospace' },
  { code: '<FR>', text: 'Roboto' },
  { code: '<FC>', text: 'Condensed Bold' },
  { code: '<IT50>', text: 'Einzug' },
  { code: '<CUT>', text: 'Schneiden' },
  { code: '<SH1>', text: 'Schrifthöhe' },
  { code: '<L1>', text: 'Linie in Höhe 1' },
  { code: '<FIT>', text: 'Breitenanpassung' },
  { code: '<NNL>', text: 'Kein Zeilenumbruch' },
  { code: '<SP1>', text: 'Vorschub in Pixel' },
  { code: '<LOGO:logo.jpg:300:Z>', text: 'Logo' }
]);

// Druckdefinition: Platzhalter, die der Fahrscheindrucker beim Druck ersetzt
export const PRINT_VARIABLES = Object.freeze([
  '#startort', '#zielort', '#preis', '#einzelpreis', '#gueltigbis', '#gueltigzeit', '#gueltig', '#datum', '#zeit',
  '#linie', '#druckernr', '#fahrername', '#fahrscheinnummer', '#vonwabe', '#nachwabe', '#tarifbez', '#passnr',
  '#fahrernr', '#laufnr', '#anzahlper', '#extra', '#unterschriften', '#tarifnr', '#firmenname'
]);
